import createVueApp from '@phoenix/createVueApp';

import { PhxsgCard } from '../../Molecules/Card';

import PhxsgPageSliderSlide from './phxsg-page-slider-slide.vue';
import PhxsgPageSlider from './phxsg-page-slider.vue';

document.querySelectorAll('.phxsg-page-slider-container').forEach((el) => {
  const app = createVueApp();
  app.component('PhxsgPageSlider', PhxsgPageSlider);
  app.component('PhxsgPageSliderSlide', PhxsgPageSliderSlide);
  app.component('PhxsgCard', PhxsgCard);
  app.mount(el);
});
